import { PermissionsSettingsType } from './types';

/* Permissions mapper */
export const PERMISSIONS: PermissionsSettingsType = {
  ccas: {
    administrator: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: ['view'],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view'],
      volunteerDetails: ['view'],
      demandsKanban: ['view'],
      demandDetails: ['view', 'exchange'],
      toolbox: ['view'],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view'],
      directoryVolunteers: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
  saad: {
    administrator: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: ['view'],
      messaging: ['view'],
      groups: [],
      todolist: [],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view'],
      volunteerDetails: ['view'],
      demandsKanban: ['view'],
      demandDetails: ['view', 'exchange'],
      toolbox: ['view'],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      neighbors: ['view'],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'actionButton',
      ],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      neighbors: ['view', 'create', 'update', 'delete', 'import'],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
  department: {
    administrator: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: [],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['town'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: [],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['town'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view'],
      campaignManagement: [],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['town'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: ['view', 'export', 'filter'],
      publish: [
        'view',
        'delete',
        'create',
        'edit',
        'createPool',
        'createAlert',
      ],
      campaignManagement: [],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['town'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
  association: {
    administrator: {
      dashboard: [],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      demandsKanban: [],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: [],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      demandsKanban: [],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: [],
      publish: ['view'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view'],
      demandsKanban: [],
      volunteerDetails: ['view'],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: [],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['district'],
      timeline: ['view', 'like', 'comment', 'delete'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      demandsKanban: [],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: [],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
  national: {
    administrator: {
      dashboard: ['view', 'export', 'filter'],
      publish: [],
      campaignManagement: [],
      publicationDetails: [],
      publicationTargetting: [],
      timeline: [],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'notify',
        'archive',
        'actionButton',
      ],
      toolbox: [],
      storage: ['view', 'create', 'move', 'delete', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: ['view'],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update', 'delete'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: ['view'],
      alerts: ['view'],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: ['view', 'export', 'filter'],
      publish: [],
      campaignManagement: [],
      publicationDetails: [],
      publicationTargetting: [],
      timeline: [],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'notify',
        'archive',
        'actionButton',
      ],
      toolbox: [],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: ['view'],
      alerts: ['view'],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: ['view', 'export', 'filter'],
      publish: [],
      campaignManagement: [],
      publicationDetails: [],
      publicationTargetting: [],
      timeline: [],
      volunteersKanban: ['view'],
      volunteerDetails: ['view'],
      demandsKanban: ['view'],
      demandDetails: ['view', 'exchange'],
      toolbox: [],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view'],
      directoryVolunteers: ['view'],
      groups: [],
      todolist: ['view'],
      alerts: [],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: ['view', 'export', 'filter'],
      publish: [],
      campaignManagement: [],
      publicationDetails: [],
      publicationTargetting: [],
      timeline: [],
      volunteersKanban: ['view', 'create', 'move', 'delete'],
      volunteerDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'archive',
      ],
      demandsKanban: ['view', 'create', 'move', 'delete', 'publish', 'archive'],
      demandDetails: [
        'view',
        'update',
        'exchange',
        'delete',
        'messaging',
        'notify',
        'actionButton',
      ],
      toolbox: [],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      neighbors: ['view', 'create', 'update'],
      directoryVolunteers: ['view', 'create', 'update', 'delete', 'import'],
      groups: [],
      todolist: ['view'],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
  real_estate_player: {
    administrator: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['group'],
      timeline: [],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: [
        'view',
        'invit',
        'viewMembers',
        'viewPendingMembers',
        'updateRoles',
      ],
      manageEntity: ['view'],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: ['view'],
      // Recrutement des membres : gestionnaires et admins de Réseau (rôle member hérité de l'agent)
      recruitment: ['view'],
      // Groupes issus de l'analyse (publications ciblées) : gestionnaires et admins de Réseau
      audiences: ['view'],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: ['view'],
    },
    agent: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['group'],
      timeline: [],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: ['view'],
      recruitment: ['view'],
      audiences: ['view'],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
    reporter: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['group'],
      timeline: [],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: ['view'],
      todolist: [],
      historyModule: ['view'],
      signals: [],
    },
    messaging: {
      dashboard: ['view', 'export', 'filter'],
      publish: ['view', 'delete', 'create', 'edit', 'createPool'],
      campaignManagement: ['view'],
      publicationDetails: ['view', 'delete'],
      publicationTargetting: ['group'],
      timeline: [],
      volunteersKanban: [],
      demandsKanban: [],
      volunteerDetails: [],
      demandDetails: [],
      toolbox: ['view'],
      storage: ['view', 'create', 'delete', 'move', 'actions'],
      manageUsers: ['view', 'viewMembers'],
      manageEntity: [],
      manageAccount: ['view', 'update'],
      advancedSettings: [],
      messaging: ['view'],
      groups: ['view'],
      todolist: [],
      historyModule: ['view', 'update', 'create'],
      signals: [],
    },
  },
};
